﻿<template>
    <q-header elevated class="bg-white text-black">
        <q-toolbar>
            <q-toolbar-title class="row items-center justify-start">
                <q-avatar square class="col col-shrink q-mr-md cursor-hand"
                          @click="$router.push( { name: 'MainPage' } )">
                    <img :src="csjLogo" alt="">
                </q-avatar>

                <div class="col col-grow" :title="ts( 'version', { version: appVersion } )">
                    {{ ts( 'appName' ) }}
                </div>

                <q-space/>

                <div class="col text-right q-mr-lg logged-user q-mr-lg" v-if="isAuthenticated">
                    {{ loggedUserName }}
                </div>

                <div class="col text-right col-shrink" v-if="canFullscreen">
                    <q-btn
                        flat :icon="isFullscreen ? 'fullscreen_exit' : 'fullscreen'" color="secondary"
                        :title="ts( isFullscreen ? 'hideFullScreen' : 'showFullScreen' )"
                        @click="toggleFullscreen"/>
                </div>
            </q-toolbar-title>
        </q-toolbar>
    </q-header>
</template>

<script setup lang="ts">
// Purpose: Create application bar

import { version } from '@/../package.json'
import csjLogo from '@/assets/csjlogo.jpg'
import { Defaults, Options } from '@/orm/models/Setting'
import SettingsRepo from '@/orm/repositories/SettingsRepo'
import { ts } from '@/plugins/i18nFormat'
import { useRepo } from 'pinia-orm'
import { useQuasar } from 'quasar'
import { computed, ref } from 'vue'

const appVersion = ref( version )

const quasar = useQuasar()

const isFullscreen = computed( () => quasar.fullscreen.isActive )
const canFullscreen = computed( () => quasar.fullscreen.isCapable )

const isAuthenticated = computed( () => ( useRepo( SettingsRepo ).getOption( Options.AuthToken, Defaults.AuthToken ) != '' ) )
const loggedUserName = computed( () => ( useRepo( SettingsRepo ).getOption( Options.AuthFullName, Defaults.AuthFullName ) ) )

function toggleFullscreen () {
    quasar.fullscreen.toggle()
}
</script>

<style lang="sass" scoped>
.cursor-hand
    cursor: pointer

.logged-user
    font-size: 75%
</style>
